import { useTheme } from "next-themes";

export function useDarkMode() {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const toggleDark = () => setTheme(isDark ? "light" : "dark");
  return { isDark, toggleDark };
}
